import { render, staticRenderFns } from "./DivisionParosComponente.vue?vue&type=template&id=40fb7baa&"
import script from "./DivisionParosComponente.vue?vue&type=script&lang=js&"
export * from "./DivisionParosComponente.vue?vue&type=script&lang=js&"
import style0 from "./DivisionParosComponente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports